module.exports = __webpack_public_path__ + "img/tools3.075260c0.png";